import { registerBlockType } from "@wordpress/blocks";

import { Fragment } from "@wordpress/element";

import {
    InnerBlocks,
    InspectorControls,  
} from "@wordpress/editor";

// Components contain several reusable React components
import {
    TextControl,
} from "@wordpress/components";

const { __ } = wp.i18n;

registerBlockType("wp-naat-button/button-block", {
    title: __("Naat Block Bouton Jaune", 'naat-editor-tools'),
    description: __("Paramètres du bouton jaune", 'naat-editor-tools'),
    icon: "button",
    category: "widgets",
    attributes: {
        link: { type: "string",},
        text: { type: "string" },
    },
    edit({ attributes, setAttributes }) {
        const { link } = attributes;
        const setLink = (link) => setAttributes({ link });
        const ALLOWED_BLOCKS = [  'core/paragraph' ];
        return (
            <Fragment>
                <h3>{__("Block du bouton jaune", 'naat-editor-tools')}</h3>
                    <InspectorControls>
                        <label>{__("Lien :", 'naat-editor-tools')}</label>
                        <TextControl
                            value={link}
                            onChange={setLink}
                            className="link"
                        />
                    </InspectorControls>
                    <p>Insert your text just below</p>
                    <InnerBlocks
                        allowedBlocks={ ALLOWED_BLOCKS }                
                    />
            </Fragment>
        );
    },
    save() {
        return (
            <InnerBlocks.Content />
        )
    },
});



// WEBPACK FOOTER //
// ./src/javascript/naat_button_block.jsx